export default {"src":"/_next/static/media/active.1b3ef876.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};